module.exports = __webpack_public_path__ + "nf.b4145a64edbe52729406.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/nf.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/nf.svg
// module chunks = styles